<template>
    <FormWrapper>
        <PageTitle title="Update Leave Approve" slot="title" link="/helpContent/Leave Approve" />
        <div v-html="userName" id="sub-heading"></div>
        <br />
        <br />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-4">
                    <InputText v-model="form.name" label="Staff" :style="{pointerEvents: display}" />
                </div>
                <div class="col-sm-4">
                    <FormSelect label="Leave Type" :items="leaveTypeList" item-name="LeaveName" item-value="ID" v-model="form.selectedLeaveType" :style="{pointerEvents: display}" />
                </div>
                
            </FormRow>
            <FormRow>
                <div class="col-sm-4">
                    <InputDate label="Start Date" v-model="form.startDate" :style="{pointerEvents: display}" /> 
                </div>
                <div class="col-sm-2">
                    <div v-html="firstDayLeaveType" id="firstDayLeaveType-heading"></div>
                </div>
            </FormRow>
            <FormRow>
                <div class="col-sm-4">
                    <InputDate label="End Date" v-model="form.endDate" :style="{pointerEvents: display}" />
                </div>
                <div class="col-sm-2">
                    <div v-html="lastDayLeaveType" id="lastDayLeaveType-heading"></div>
                </div>
            </FormRow>
            <FormRow>
                <div class="col-sm-4">
                    <InputText v-model="form.noOfDays" label="Number of Days" :style="{pointerEvents: display}" />
                </div>
                <div class="col-sm-4">
                    <InputText v-model="form.appliedOn" label="Applied On" :style="{pointerEvents: display}" />
                </div>
                <div class="col-sm-4">
                    <InputTel v-model="form.emergencyContact" label="Emergency Contact" :style="{pointerEvents: display}" />
                </div>
            </FormRow>
            <formRow><div class="col-sm-6">
                    <InputTextArea v-model="form.reason" label="Reason" :style="{pointerEvents: display}" />
                </div></formRow>
            <FormRow>
                <h4>Manager Comments</h4>
                
                <div  v-if="advanceLeave">
                    <FormCheckbox v-model="form.advanceLeaveCount">Advance Leave</FormCheckbox>
                </div>
                <br/>
                <div class="col-sm-4">
                    <InputTextArea v-model="form.notes" label="Notes" />
                </div>
            </FormRow>
            <br>
        </ValidationObserver>
        <FormRow>
            <div class="col-sm-6">
                <ButtonGroup>
                    <FormButton type="info" @click="()=>{$router.go(-1)}">Back</FormButton>
                    <FormButton type="success" @click="onAprroveOrReject(1)">Approve</FormButton>
                    <FormButton type="danger" @click="onAprroveOrReject(0)">Reject</FormButton>
                    <!-- <FormButton type="primary" @click="onResubmit()">Resubmit</FormButton> -->
                </ButtonGroup>
            </div>
        </FormRow>
        <!-- <FormRow>
            <div class="col-md-12">
                <h4>Leave Matrix</h4>
                <DataTable :actions="true"
                    :data="leaveMatrixData"
                    :columns="tableLeaveMatrix"
                    :is-loading="isLoading">
                </DataTable>
            </div>
        </FormRow>
        <FormRow>
            <div class="col-md-8">
                <h4>Leave Planner</h4>
                <DataTable :actions="true"
                    :data="leavePlannerMatrix"
                    :columns="tableLeavePlanner"
                    :is-loading="isLoading">
                </DataTable>
            </div>
        </FormRow> -->
        <Popup title="Success" type="success" :value="showMessage.isVisible"  @close="() => (showMessage.isVisible = false)" :closable="true">
            {{ showMessage.message }}
            <div slot="footer">
                <FormButton @click="()=>{$router.go(-1)}">Ok</FormButton>
            </div>
        </Popup>
    </FormWrapper>
</template> 

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import loadingMixin from 'Mixins/loadingMixin';
    import {getUserNameById, leaveType, leaveMatrix, leavePlanMatrix, getLeaveDetailsToApprove, changeLeaveStatus, reSubmitLeave} from '../api';
    import InputDate from "Components/form/InputDate";
    // import tableLeaveMatrix from "./tableLeaveMatrix";
    import tableLeavePlanner from "./tableLeavePlanner";
    // import DataTable from "Components/DataTable";
    import InputTel from "Components/form/InputTel";
    import FormCheckbox from 'Components/form/FormCheckbox';
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "Update",
        mixins: [loadingMixin],
        components: {
            FormCheckbox,
            FormWrapper,
            PageTitle,
            // DataTable,
            InputDate,
            InputTel,
            ValidationObserver
        },
        data() {
            return {
                showMessage:{
                    isVisible: false,
                    message: ''
                },
                form:{
                    name: '',
                    selectedLeaveType: null,
                    startDate: '',
                    endDate: '',
                    reason: '',
                    noOfDays: '',
                    appliedOn: '',
                    emergencyContact: null,
                    notes:'',
                    advanceLeaveCount:0
                },
                advanceLeave:false,
                firstDayLeaveType: '',
                lastDayLeaveType: '',
                userName: '',
                display:'none !important',
                // tableLeaveMatrix,
                tableLeavePlanner,
                leaveMatrixData: [],
                leavePlannerMatrix: [],
                leaveTypeList: []
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getAllList(),
            this.getLeaveRecord(),
            this.getDataByFilter()
        },
        methods: {
            getDataByFilter() {
                if(this.$route.params.id){
                    setTimeout(() => {
                        this.showLoader();
                        const filters = {};
                        filters.staffId = atob(this.$route.params.staffId);
                        filters.leaveId = atob(this.$route.params.id);
                        const data = {
                            filterjson: {
                                filter: [filters]
                            }
                        };
                        getLeaveDetailsToApprove(data)
                            .then(this.handleResponse)
                            .catch(this.handleError)
                    },
                    50
                    )
                }
            },
            onAprroveOrReject(val){
                this.$refs.validator.validate().then(result=>{
                    if(result){
                        this.showMessage.isVisible=false;
                        const data={
                            staffId: this.$route.params.staffId?atob(this.$route.params.staffId):0,
                            staffLeaveId: this.$route.params.id?atob(this.$route.params.id):0,
                            toDoId: this.$route.params.toDoId?atob(this.$route.params.toDoId):0,
                            approvalStatusId: (val===1)?86:88, //86 -> Approved & 88 -> Reject
                            approvalComment: this.form.notes,
                            leaveTypeId: this.form.selectedLeaveType,
                            LWPApprovalStatus:this.form.advanceLeaveCount?'A':'N'
                        };
                        changeLeaveStatus(data).then((res)=>{
                            this.form = {};
                            this.showMessage.isVisible=true;
                            this.showMessage.message=res.data[0].message;
                        })
                    }
                })
            },
            onResubmit(){
                this.$refs.validator.validate().then(result=>{
                    if(result){
                        this.showMessage.isVisible=false;
                        const data={
                            staffId: this.$route.params.staffId?atob(this.$route.params.staffId):0,
                            staffLeaveId: this.$route.params.id?atob(this.$route.params.id):0,
                            toDoId: this.$route.params.toDoId?atob(this.$route.params.toDoId):0,
                            resubmitComment: this.form.notes
                        };
                        reSubmitLeave(data).then((res)=>{
                            this.form = {};
                            this.showMessage.isVisible=true;
                            this.showMessage.message=res.data[0].message;
                        })
                    }
                })
            }, 
            handleResponse(response) {
                this.hideLoader();
                this.form.selectedLeaveType = response.data[0].LeaveType_id;
                this.form.startDate = response.data[0].LeaveDateStart1;
                this.form.endDate = response.data[0].LeaveDateEnd1;
                this.form.appliedOn = response.data[0].AppliedOn;
                this.form.noOfDays = response.data[0].Num_Days;
                this.form.reason = response.data[0].Reason;
                this.firstDayLeaveType = response.data[0].FirstDayLeaveType;
                this.lastDayLeaveType = response.data[0].LastDayLeaveType;
                this.form.emergencyContact = response.data[0].EmergencyContact!='null'?response.data[0].EmergencyContact:'';
                if(response.data[0].advancecount>0){
                    this.advanceLeave=true;
                }
                else{
                    this.advanceLeave=false;
                }
            },
            getLeaveRecord() {
                if (this.$route.params.staffId) {
                    let data = {
                        staff_id: atob(this.$route.params.staffId),
                    };
                    // leaveMatrix(data).then((res) => {
                    //     this.leaveMatrixData = res.data;
                    // });
                    // leavePlanMatrix(data).then((res) => {
                    //     this.leavePlannerMatrix = res.data;
                    // });
                }
            },
            async getAllList() {
                await leaveType().then((res)=>{
                    this.leaveTypeList=res.data;
                });

                const filters = {};
                filters.userId = atob(this.$route.params.staffId);
                const data = {
                    filterjson: {
                        filter: [filters]
                    }
                };
                await getUserNameById(data).then((res)=>{
                    this.userName = res.data[0].name;
                    this.form.name = res.data[0].name;
                });
            },
        }
    } 
</script>
<style lang="scss">
    #firstDayLeaveType-heading, #lastDayLeaveType-heading, #sub-heading{
        font-weight: 900;
        padding-top: 12px;
    }

    #sub-heading{
        float: right;
    }

    body{
        padding-right: 0px !important;
        overflow: auto !important;
    }

    .Page_content_1OD76{
        display: -webkit-box !important;
    }
    textarea{
        height: 110px !important;
    }
</style>